/**
 * Speciality master — the GET /speciality/:code response that drives
 * every speciality-keyed downstream call (questions tree, ILF/DLF).
 * Keyed by speciality code (the app uses a single default code per
 * session, so consumers usually read `currentSpeciality`).
 */
class SpecialityStore {
  #listeners = new Set();
  /** @type {{ code: string, data: import("@/shared/dtos").SpecialityMasterResponse } | null} */
  #slot = null;

  /** @returns {import("@/shared/dtos").SpecialityMasterResponse | null} */
  getSpeciality(code) {
    return this.#slot?.code === code ? this.#slot.data : null;
  }

  /** Currently-loaded speciality, ignoring the code key. */
  get currentSpeciality() { return this.#slot?.data ?? null; }

  setSpeciality(code, data) {
    this.#slot = { code, data };
    this.#notify();
  }

  subscribe(listener) {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  }

  #notify() { this.#listeners.forEach((l) => l()); }

  clear() {
    this.#slot = null;
    this.#notify();
  }
}

const specialityStore = new SpecialityStore();
export default specialityStore;
